import { render, staticRenderFns } from "./SalesPage.vue?vue&type=template&id=00491e5c&scoped=true&"
import script from "./SalesPage.vue?vue&type=script&lang=js&"
export * from "./SalesPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesPage.vue?vue&type=style&index=0&id=00491e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00491e5c",
  null
  
)

export default component.exports